import { inject, observer } from "mobx-react";
import AgGrid from "../../../common/components/ag-grid/ag-grid";
import React from "react";
import moment from "moment";
import CheckboxRenderer from "../../../common/CheckboxRenderer";
import SmartSelectClearable from "../../../common/SmartSelectClearable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumericCellEditorAllowNegative } from "../../../common/NumericCellEditorAllowNegative";
import RestEndPoint from "../../../common/RestEndPoint";
import {
  faCopy,
  faFileExport,
  faPlus,
  faSave,
  faSync,
} from "@fortawesome/free-solid-svg-icons";
import commonstore from "../../../common/commonstore";
import {
  DateFormatter,
  DateTimeFormatter,
} from "../../../common/DateFormatterWithZone";
import {
  DecimalFormatter2Digits,
  DecimalFormatter4Digits,
} from "../../../common/NumberFormatter";
import gainLossReferenceScreenStore from "../store/gain-loss-reference-screen--store";
import { Datepicker } from "../../../common/Datepicker";
import GainLossSmartSelect from "./gainloss-smartSelect";
import "./gainloss-transaction-screen.scss";

@inject("GainLossReferenceDataStore")
@observer
class GainLossReferenceScreen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gridOptions: {
        newRowNotSaved: false,
        rowSelection: "multiple",
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
          cellStyle: (param) => {
            if (this.IsOverflow(param) === true) return { overflow: "visible" };
          },
        },
        frameworkComponents: {
          SmartSelectClearable: GainLossSmartSelect,
          booleanCellEditor: CheckboxRenderer,
          dateFormatter: DateFormatter, //for effective start date
          dateTimeFormatter: DateTimeFormatter, //for audit info
          datePicker: Datepicker,
          decimalFormatter: DecimalFormatter2Digits, //for 3 digits round off materiality)
          decimalFormatter3Digits: DecimalFormatter4Digits, //for 4 digit round off (tolerance and offset)
        },
      },
      screenrowData: [],
      editRowData: "",
      rowSelected: false,

      jurisdictionTxt: "select jurisdiction",
      monthYearTxt: "",
      isSubmitting: false,
      currentColumnDef: [],
      productTblName: "",
      readOnlyRole: false,
      selectedData: [],
      subsystemlected: "",
      hasProductsData: false,
      productSelectedData: [],
      selectedRowsCount: 0,
      copyColumnExists: false,

      availableProducts: [],
      availableReferenceData: [],
      copiedEffectiveStartDate: "",
      copiedSubSystem: "",

      isCopyRow: false,
      editRowData: "",
      isFormVisible: false,
      formRowData: [],

      //for products add edit
      productsrowData: [],
      editProductsRowData: "",
      productRowSelected: false,

      productsGridOption: {
        productnewRowNotSaved: false,
        rowSelection: "single",
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: "always",
        suppressContextMenu: true,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: "agTotalAndFilteredRowCountComponent",
              align: "left",
            },
            {
              statusPanel: "agAggregationComponent",
              statusPanelParams: {
                aggFuncs: ["avg", "count", "min", "max", "sum"],
              },
            },
          ],
        },
        sideBar: {
          toolPanels: [
            {
              id: "columns",
              labelDefault: "Columns",
              labelKey: "columns",
              iconKey: "columns",
              toolPanel: "agColumnsToolPanel",
            },
          ],
          showToolPanel: false,
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true,
          cellStyle: (param) => {
            if (this.IsOverflow(param) === true) return { overflow: "visible" };
          },
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelectClearable,
          booleanCellEditor: CheckboxRenderer,
          NumericCellEditor: NumericCellEditorAllowNegative,
          dateTimeFormatter: DateTimeFormatter,
          dateFormatter: DateFormatter, //for effective start date
        },
      },
    };
  }

  IsOverflow(params) {
    if (params.colDef.field === "isActive") {
      return true;
    } else return false;
  }

  setColumnDef = async () => {
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await GainLossReferenceDataStore.setColumnDef(currentScreen, CommonStore);
  };
  setProductColumnDef = async () => {
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    const parentScreenName = "GainLossProductScreen";
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await GainLossReferenceDataStore.setProductColumnDef(
      currentScreen,
      CommonStore
    );
  };
  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );

    return currentScreenChildren;
  };
  getCurrentScreenChildrenByNm = (screenName) => {
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName && x.screen.name == screenName
    );

    return currentScreenChildren;
  };
  handleJurisdictionChange = async (e) => {
    var jurisdiction = e.target.value;
    this.state.jurisdictionTxt = jurisdiction;
    const { GainLossReferenceDataStore } = this.props;
    GainLossReferenceDataStore.resetReferenceData();

    GainLossReferenceDataStore.selectedJurisdiction = jurisdiction;

    this.getReferenceData();
    e.preventDefault();
    this.HideColumns();
    this.RenameColumnNames();
    this.props.GainLossReferenceDataStore.division =
      await GainLossReferenceDataStore.geEntityName("Division/District");
    this.props.GainLossReferenceDataStore.system =
      await GainLossReferenceDataStore.geEntityName("System");
    this.props.GainLossReferenceDataStore.subSystem =
      await GainLossReferenceDataStore.geEntityName("SubSystem");
    this.props.GainLossReferenceDataStore.types =
      await GainLossReferenceDataStore.geEntityName("Type");
    this.props.GainLossReferenceDataStore.products =
      await GainLossReferenceDataStore.geEntityName("Product");

    //reset the isAdd and IsCopy flags so that on jurisdiction change user can add / copy new rows
    this.setState({ newRowNotSaved: false });
    this.setState({ isCopyRow: false });
    this.setState({ productnewRowNotSaved: false });
    this.setState({ rowSelected: false, fileNameExcel: null });
  };

  getReferenceData = async () => {
    this.setState({ rowSelected: false, editRowData: "" });
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    const { jurisdictionTxt } = this.state;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await GainLossReferenceDataStore.getScreenData(
      currentScreen,
      jurisdictionTxt,
      CommonStore
    );
  };
  getProductsData = async () => {
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    GainLossReferenceDataStore.getProductsData(
      this.getCurrentScreen,
      this.subsystem,
      this.effectiveStartDate,
      this.effectiveEndDate,
      CommonStore
    );
    this.state.hasProductsData = true;
  };
  onSelectionChanged = async (e) => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    const selecteddata = selectedRow[0]?.subSystem;
    this.subsystem = selecteddata;
    this.effectiveStartDate = selectedRow[0]?.effectiveStartDate;
    this.effectiveEndDate = selectedRow[0]?.effectiveEndDate;
    this.selectedData = selectedRow;
    this.setState({
      rowSelected: selectedRow.length,
      editRowData: selectedRow[0],
    });
    this.setState({
      selectedRowsCount: this.state.gridOptions.api.getSelectedRows().length,
    });
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    const parentScreenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    GainLossReferenceDataStore.getProductsData(
      currentScreen,
      this.subsystem,
      this.effectiveStartDate,
      this.effectiveEndDate,
      CommonStore
    );

    this.state.hasProductsData = true;

    //setting products cols
    this.setProductColumnDef();
  };

  getKeyColumnName = () => {
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : "id";

    return keyColumnName;
  };

  selectNode(nodeIndex) {
    let node = this.state.gridOptions.api.getDisplayedRowAtIndex(nodeIndex);
    node.setSelected(true);
  }

  addNewRow = async () => {
    this.setState({ newRowNotSaved: true });
    const keyColumnName = this.getKeyColumnName();
    let rowCount = this.state.gridOptions.api.getDisplayedRowCount();
    let newRowData = {};

    this.props.GainLossReferenceDataStore.screenColumnDefinitions[
      "GainLossReferenceScreen"
    ].forEach((col) => {
      col.isEditableCol = false;
      newRowData[col.field] = null;
    });

    newRowData.isNewRow = true;
    newRowData[keyColumnName] = 0;
    newRowData["tolerance"] = 0.0;
    newRowData["offset"] = 0.0;
    newRowData["materiality"] = 0.0;
    newRowData["gainLossBarrels"] = 0.0;
    newRowData["gainLossPercentage"] = 0.0;
    newRowData["maxGainLossBarrels"] = 0.0;
    newRowData["gainLossM3"] = 0.0;
    newRowData["maxGainLossM3"] = 0.0;

    this.state.gridOptions.api.insertItemsAtIndex(0, [newRowData]);
    let cols = this.state.gridOptions.columnApi.getAllDisplayedColumns();
    const NonPinnedColumn = cols.filter((x) => !x.pinned);
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0]);
    this.state.gridOptions.api.startEditingCell({
      rowIndex: 0,

      colKey:
        this.state.gridOptions.columnApi.getDisplayedCenterColumns()[0].colId,
    });
    this.state.rowIndex = 1;
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0]);
    this.selectNode(0);
  };

  addNewRowForProduct = async () => {
    this.setState({ productnewRowNotSaved: true });

    //get current screen
    const screenName = "GainLossProductScreen";
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );

    //get key col
    const { screenColumns } = currentScreen;
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : "id";

    //add row
    let rowCount = this.state.productsGridOption.api.getDisplayedRowCount();
    let newRowData = {};

    this.props.GainLossReferenceDataStore.productColumnDefinitions[
      "GainLossProductScreen"
    ].forEach((col) => {
      newRowData[col.field] = null;
    });

    newRowData.isNewRow = true;
    newRowData[keyColumnName] = 0;
    newRowData["subSystem"] = this.subsystem;
    newRowData["effectiveStartDate"] = this.effectiveStartDate;
    newRowData["effectiveEndDate"] = this.effectiveEndDate;

    this.state.productsGridOption.api.insertItemsAtIndex(0, [newRowData]);
    let cols = this.state.productsGridOption.columnApi.getAllDisplayedColumns();
    const NonPinnedColumn = cols.filter((x) => !x.pinned);
    this.state.productsGridOption.api.ensureColumnVisible(NonPinnedColumn[0]);
    this.state.productsGridOption.api.startEditingCell({
      rowIndex: 0,
      // gets the first columnKey
      colKey:
        this.state.productsGridOption.columnApi.getDisplayedCenterColumns()[0]
          .colId,
    });
    this.state.productsGridOption.api.ensureColumnVisible(NonPinnedColumn[0]);

    let node = this.state.productsGridOption.api.getDisplayedRowAtIndex(0);
    node.setSelected(true);
  };

  copyRecord = async () => {
    const keyColumnName = this.getKeyColumnName();

    let newRowData = this.state.gridOptions.api.getSelectedRows()[0];
    const rowObj = {};
    const rowToCopy = Object.assign(rowObj, newRowData);
    const { screenColumns } = this.getCurrentScreen();
    const keyColumn = screenColumns.filter((x) => x.toRemoveOnCopy);
    keyColumn.forEach((col) => {
      rowToCopy[col.name] = null;
    });

    rowToCopy.isNewRow = true;
    rowToCopy[keyColumnName] = 0;

    this.state.gridOptions.api.insertItemsAtIndex(0, [rowToCopy]);
    let cols = this.state.gridOptions.columnApi.getAllDisplayedColumns();
    this.state.gridOptions.api.ensureColumnVisible(cols[1]);
    this.state.gridOptions.api.startEditingCell({
      rowIndex: 0,
      // gets the first columnKey
      colKey:
        this.state.gridOptions.columnApi.getDisplayedCenterColumns()[0].colId,
    });
    this.setState({ newRowNotSaved: true });
    this.setState({ isCopyRow: true });

    const NonPinnedColumn = cols.filter((x) => !x.pinned);
    this.state.gridOptions.api.ensureColumnVisible(NonPinnedColumn[0]);
  };
  getCurrentScreen = () => {
    const screenName = this.props.path.split("/").pop();
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    return currentScreen;
  };
  HideColumns = () => {
    if (this.state.jurisdictionTxt === "Plains - South") {
      this.state.gridOptions.columnApi.setColumnVisible(
        "gainLossBarrels",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "maxGainLossBarrels",
        true
      );
      this.state.gridOptions.columnApi.setColumnVisible("tolerance", false);
      this.state.gridOptions.columnApi.setColumnVisible("offset", false);
      this.state.gridOptions.columnApi.setColumnVisible("materiality", false);
      this.state.gridOptions.columnApi.setColumnVisible("gainLossM3", false);
      this.state.gridOptions.columnApi.setColumnVisible("maxGainLossM3", false);
    } else if (this.state.jurisdictionTxt === "Plains - North") {
      this.state.gridOptions.columnApi.setColumnVisible("tolerance", true);
      this.state.gridOptions.columnApi.setColumnVisible("offset", false);
      this.state.gridOptions.columnApi.setColumnVisible("materiality", false);
      this.state.gridOptions.columnApi.setColumnVisible(
        "gainLossBarrels",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible(
        "maxGainLossBarrels",
        false
      );
      this.state.gridOptions.columnApi.setColumnVisible("gainLossM3", true);
      this.state.gridOptions.columnApi.setColumnVisible("maxGainLossM3", true);
    }
  };
  RenameColumnNames = () => {
    if (this.state.jurisdictionTxt === "Plains - South") {
      const newColDef = this.state.gridOptions.columnDefs;
      newColDef.forEach(function (colDef) {
        if (colDef.field === "division") {
          colDef.headerName = "Division";
        }
      });

      this.state.gridOptions.api.setColumnDefs(newColDef);
    } else if (this.state.jurisdictionTxt === "Plains - North") {
      const newColDef = this.state.gridOptions.columnDefs;
      newColDef.forEach(function (colDef) {
        if (colDef.field === "division") {
          colDef.headerName = "District";
        }
      });

      this.state.gridOptions.api.setColumnDefs(newColDef);
    }
    if (this.state.copyColumnExists === false) {
      const newColDef = this.state.gridOptions.columnDefs;
      newColDef.splice(0, 0, {
        field: "Copy",
        headerName: "Copy",
        width: 80,
        editable: false,
        colId: "copy",
        pinned: "left",
        checkboxSelection: true,
        groupSelectsChildren: true,
      });

      this.state.gridOptions.api.setColumnDefs(newColDef);
      this.state.copyColumnExists = true;
    }
  };
  render() {
    const {
      headerDetails,
      screenRowData,
      rowData,
      hasScreenData,
      screenColumnDefinitions,
      productsData,
      productColumnDefinitions,
    } = this.props.GainLossReferenceDataStore;
    const parentScreen = this.getCurrentScreenParent();
    let colDef = screenColumnDefinitions["GainLossReferenceScreen"];
    let productColDef = productColumnDefinitions["GainLossProductScreen"];
    const { selectedData, productSelectedData } =
      this.props.GainLossReferenceDataStore;
    this.availableReferenceData = rowData;
    if (!this.state.isCopyRow) this.availableProducts = productsData;
    return (
      <div className="gainloss-reference-wrapper">
        <div className="row">
          <div className="col-md-12">
            <div className="container cb-title-container">
              <h3 className="cb-title">{parentScreen.screen.title}</h3>
            </div>
            <div className="col-md-12">
              <div className="row nglteam-header-row  sticky-top rounded">
                <div className="col-md-3">
                  <div className="row">
                    <div className="col-md-4">
                      <label className="nglteam-header-row-label">
                        Jurisdiction:
                      </label>
                      <br />
                    </div>
                    <div className="col-md-6">
                      <select onChange={this.handleJurisdictionChange}>
                        <option value="" disabled selected hidden>
                          Select Jurisdiction
                        </option>

                        {headerDetails.jurisdictionDpDwnList.map(
                          (option, key) => (
                            <option key={key} value={option.jurisdiction}>
                              {option.jurisdiction}
                            </option>
                          )
                        )}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              {rowData && (
                <AgGrid
                  gridID={"ReferenceScreenData"}
                  gridOptions={this.state.gridOptions}
                  columnDefs={colDef}
                  rowData={screenRowData.ReferenceData}
                  onSelectionChanged={this.onSelectionChanged}
                  onCellValueChanged={this.onCellValueChanged.bind(this)}
                />
              )}
            </div>
            <div className="row btn-toolbar pull-right">
              <button
                type="copy"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={this.copyRecord}
                disabled={
                  this.state.isCopyRow ||
                  this.state.newRowNotSaved ||
                  this.state.selectedRowsCount == 0 ||
                  rowData.length == 0
                }
              >
                <FontAwesomeIcon icon={faCopy} />
                Copy
              </button>
              <button
                type="add"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                disabled={this.state.newRowNotSaved}
                onClick={this.addNewRow}
              >
                <FontAwesomeIcon icon={faPlus} />
                Add
              </button>

              <button
                type="save"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={this.saveReferenceData}
                disabled={selectedData == 0}
              >
                <FontAwesomeIcon icon={faSave} />
                Save
              </button>
              <button
                type="refresh"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                onClick={this.refreshData}
              >
                <FontAwesomeIcon icon={faSync} />
                Refresh / Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary btn-grid active"
                aria-expanded="false"
                disabled={rowData.length == 0}
                onClick={this.exportToExcel}
              >
                <FontAwesomeIcon icon={faFileExport} />
                Export
              </button>
            </div>
          </div>
        </div>
        {this.state.hasProductsData && productsData && (
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-9 ">
                <label className="cb-title">Products</label>
              </div>
              <div className="product-table-container">
                {productsData && (
                  <AgGrid
                    gridID={"GainLossProductScreen"}
                    gridOptions={this.state.productsGridOption}
                    domLayout="autoHeight"
                    columnDefs={productColDef}
                    rowData={productsData}
                    onCellValueChanged={this.onProductCellValueChanged.bind(
                      this
                    )}
                  />
                )}
                <div className="row btn-toolbar pull-right">
                  <button
                    type="add"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    disabled={this.state.productnewRowNotSaved}
                    onClick={this.addNewRowForProduct}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                    Add
                  </button>
                  <button
                    type="save"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    onClick={this.saveProductData}
                    disabled={productSelectedData.length == 0}
                  >
                    <FontAwesomeIcon icon={faSave} />
                    Save
                  </button>
                  <button
                    type="refresh"
                    className="btn btn-primary btn-grid active"
                    aria-expanded="false"
                    onClick={this.refreshProductsData}
                  >
                    <FontAwesomeIcon icon={faSync} />
                    Refresh / Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  saveReferenceData = async () => {
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    this.props.GainLossReferenceDataStore.isCopy = this.state.isCopyRow;
    await gainLossReferenceScreenStore.saveData(CommonStore);

    if (GainLossReferenceDataStore.referenceDataSaved) {
      await this.getReferenceData();

      if (this.state.isCopyRow && this.availableProducts?.length > 0) {
        var newCopiedRow = this.availableReferenceData?.reduce((max, cur) =>
          +max.transactionBaseId > +cur.transactionBaseId ? max : cur
        );
        //this.selectNode(refrowIndex);
        this.copiedEffectiveStartDate = newCopiedRow?.effectiveStartDate;
        this.copiedEffectiveEndDate = newCopiedRow?.effectiveEndDate;
        this.copiedSubSystem = newCopiedRow?.subSystem;
        const { productSelectedData } = this.props.GainLossReferenceDataStore;
        let toAddUpdate = this.availableProducts;

        const currentUser = RestEndPoint.getCurrentUserName();
        const mstTime = new Date().toLocaleString("en-US", {
          timeZone: "America/Denver",
        });

        const addUpdateData = toAddUpdate.map((item) => {
          item.productId = 0;
          item.effectiveStartDate = this.copiedEffectiveStartDate;
          item.effectiveEndDate = this.copiedEffectiveEndDate;
          item.subSystem = this.copiedSubSystem;
          item.createdBy = currentUser;
          item.createdDate = mstTime;
          return item;
        });

        addUpdateData.forEach((element) => {
          productSelectedData.push(Object.assign({}, element));
        });

        this.saveProductData();
      }

      this.setState({ newRowNotSaved: false });
      this.setState({ isCopyRow: false });
      this.setState({ selectedRowsCount: 0 });
    }
    this.state.screenrowData = [];
  };
  saveProductData = async () => {
    try {
      const { CommonStore, GainLossReferenceDataStore } = this.props;
      await gainLossReferenceScreenStore.saveProductData(CommonStore);
    } finally {
      const { GainLossReferenceDataStore } = this.props;
      if (GainLossReferenceDataStore.productDataSaved) {
        await this.getProductsData();
        await this.getReferenceData();
        this.setState({ productnewRowNotSaved: false }); //to make sure a new row row is not added until the existing row is save
      }
      this.state.productsrowData = [];
    }
  };
  onCellValueChanged = function (e) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const { selectedData } = this.props.GainLossReferenceDataStore;
    const keyColumnName = this.getKeyColumnName();
    const mstTime = new Date().toLocaleString("en-US", {
      timeZone: "America/Denver",
    });
    if (e.oldValue != e.newValue) {
      if (
        e.column.colId === "isActive" &&
        (e.newValue === null || e.oldValue === null)
      ) {
        if (e.newValue === null)
          e.node.setDataValue(e.colDef.field, e.oldValue);
        else if (e.oldValue === null)
          e.node.setDataValue(e.colDef.field, e.newValue);
      } else {
        const existingRowIndex = selectedData.findIndex(
          (x) => x[keyColumnName] === e.data[keyColumnName]
        );
        if (existingRowIndex > -1) {
          if (e.data["transactionBaseId"] > 0) {
            e.data["updatedBy"] = currentUser;
            e.data["updatedDate"] = mstTime;
          }
          selectedData[existingRowIndex] = e.data;
        } else {
          if (e.data["createdBy"] === null || this.state.isCopyRow) {
            e.data["createdBy"] = currentUser;
            e.data["createdDate"] = mstTime;
            e.data["updatedBy"] = null;
            e.data["updatedDate"] = null;
          }
          if (e.data["transactionBaseId"] > 0) {
            e.data["updatedBy"] = currentUser;
            e.data["updatedDate"] = mstTime;
          }
          selectedData.push(e.data);
        }
        this.state.gridOptions.api.refreshCells();
        if (e.newValue !== null) {
          e.node.setDataValue(e.colDef.field, e.newValue);
          this.state.gridOptions.api.refreshCells();
        } else {
          e.node.setDataValue(e.colDef.field, e.oldValue);
        }
      }
    }
  };

  onProductCellValueChanged = function (e) {
    const currentUser = RestEndPoint.getCurrentUserName();
    const { productSelectedData } = this.props.GainLossReferenceDataStore;

    const mstTime = new Date().toLocaleString("en-US", {
      timeZone: "America/Denver",
    });
    //get current screen
    const screenName = "GainLossProductScreen";
    const currentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === screenName
    );
    //get key col
    const { screenColumns } = currentScreen;
    const keyColumn = screenColumns.find((x) => x.isKey);
    let keyColumnName = keyColumn ? keyColumn.name : "id";
    if (e.oldValue != e.newValue) {
      if (
        e.column.colId === "isActive" &&
        (e.newValue === null || e.oldValue === null)
      ) {
        if (e.newValue === null)
          e.node.setDataValue(e.colDef.field, e.oldValue);
        else if (e.oldValue === null)
          e.node.setDataValue(e.colDef.field, e.newValue);
      } else {
        const existingRowIndex = productSelectedData.findIndex(
          (x) => x[keyColumnName] === e.data[keyColumnName]
        );

        if (existingRowIndex > -1) {
          if (e.data["productId"] > 0) {
            e.data["updatedBy"] = currentUser;
            e.data["updatedDate"] = mstTime;
          }
          productSelectedData[existingRowIndex] = e.data;
        } else {
          if (e.data["createdBy"] === null) {
            e.data["createdBy"] = currentUser;
            e.data["createdDate"] = mstTime;
            e.data["updatedBy"] = null;
            e.data["updatedDate"] = null;
          }
          if (e.data["productId"] > 0) {
            e.data["updatedBy"] = currentUser;
            e.data["updatedDate"] = mstTime;
          }
          e.data["subSystem"] = this.subsystem;
          e.data["effectiveStartDate"] = this.effectiveStartDate;
          e.data["effectiveEndDate"] = this.effectiveEndDate;
          productSelectedData.push(e.data);
        }
        this.state.productsGridOption.api.refreshCells();
        if (e.newValue !== null) {
          //e.node.setDataValue(e.colDef.field, e.newValue);
          this.state.productsGridOption.api.refreshCells();
        } else {
          e.node.setDataValue(e.colDef.field, e.oldValue);
        }
      }
    }
  };
  formatExportValues = (params) => {
    switch (params?.column?.colId) {
      case "createdDate":
      case "updatedDate":
        return params?.value
          ? moment(params?.value).format("MM/DD/YYYY h:mm a")
          : "";
      case "effectiveStartDate":
        return params?.value ? moment(params?.value).format("MM/DD/YYYY") : "";
      case "effectiveEndDate":
          return params?.value ? moment(params?.value).format("MM/DD/YYYY") : "";  
      default:
        return params?.value;
    }
  };

  exportToExcel = () => {
    const parentScreenName = this.props.path.split("/").pop();
    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: parentScreenName,
    };
    var today = new Date();
    const formattedDate = moment(today).format("YYYYMMDDhhmmss");
    const currentSheet = parentScreenName;
    let fileNameExcelExport =
      currentSheet + "_Export_All_" + formattedDate + "";
    const visibleColumns =
      this.state.gridOptions.api.gridOptionsWrapper.columnApi.getAllDisplayedColumns();
    const columnsToExport = visibleColumns
      .filter((item) => item.colId !== "copy")
      .map((item) => item.colId);
    this.state.gridOptions.api.exportDataAsExcel({
      fileName: fileNameExcelExport,
      sheetName: currentSheet,
      processCellCallback: this.formatExportValues,
      columnKeys: columnsToExport,
    });
  };
  componentDidMount = async () => {
    await this.refreshHeader();
    await this.setColumnDef();
    await this.refreshData();
  };
  refreshData = async () => {
    this.setState({ newRowNotSaved: false });
    this.setState({ isCopyRow: false });
    this.setState({ productnewRowNotSaved: false });
    this.setState({ rowSelected: false, fileNameExcel: null });
    this.setState({ selectedRowsCount: 0 });
    await this.getReferenceData();
    //to remove products grid on reference refresh
    this.props.GainLossReferenceDataStore.productsData = null;
  };
  refreshProductsData = async () => {
    this.setState({ productnewRowNotSaved: false });
    await this.getProductsData();
    this.props.GainLossReferenceDataStore.productsData = null;
  };
  refreshHeader = async () => {
    const { CommonStore, GainLossReferenceDataStore } = this.props;
    await GainLossReferenceDataStore.getHeaderData(CommonStore);
  };
  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split("/").pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };
}
export default GainLossReferenceScreen;
